export const environment = {
  production: false,
  baseUrl: 'http://live.cextrapre.it',
  api: '//apidev.cws.otosrl.com',
};
